import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "@/components/Breadcrumb";
import SEO from "@/components/SEO";
import AdSlot from "@/components/AdSlot";
import axios from "axios";
import { Calendar, User } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const { t } = useI18n();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <SEO title="Blog — ImageKitHub" description="Guides on image SEO, compression, WebP, PNG, JPG, photography, and Canva tips." />
      <Breadcrumb items={[{ label: t("nav.blog") }]} />
      <h1 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 dark:text-white">{t("blog.title")}</h1>
      <p className="mt-2 text-slate-500 dark:text-slate-400">{t("blog.subtitle")}</p>

      <AdSlot label="Sponsored" />

      {loading ? (
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {[1,2,3].map((i) => <div key={i} className="h-64 rounded-2xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-[#121316] animate-pulse" />)}
        </div>
      ) : posts.length === 0 ? (
        <div className="mt-16 p-12 rounded-2xl border-2 border-dashed border-slate-200 dark:border-white/10 text-center">
          <p className="text-slate-500 dark:text-slate-400">{t("blog.empty")}</p>
        </div>
      ) : (
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} className="group flex flex-col rounded-2xl border border-slate-200 dark:border-white/10 overflow-hidden hover:border-blue-500/40 transition-colors">
              {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-40 object-cover" loading="lazy" />}
              <div className="p-5 flex-1 flex flex-col">
                <span className="text-xs font-semibold uppercase tracking-widest text-blue-600 dark:text-blue-400">{p.category}</span>
                <h3 className="mt-2 text-lg font-semibold text-slate-900 dark:text-white group-hover:text-blue-600 transition-colors">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-500 dark:text-slate-400 line-clamp-3">{p.excerpt}</p>
                <div className="mt-4 flex items-center gap-3 text-xs text-slate-400 pt-4 border-t border-slate-100 dark:border-white/5">
                  <span className="flex items-center gap-1"><User size={11} /> {p.author}</span>
                  <span className="flex items-center gap-1"><Calendar size={11} /> {new Date(p.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
